<template>
    <div class="no-results-message">
        <img class="no-results-message__image" :src="`${publicPath}/images/sad-face.png`" v-if="face"/>
        <Icon v-if="icon" :height="32" :width="32" class="no-results-message__icon">
            <slot name="icon"/>
        </Icon>
        <div class="no-results-message__text copy">
            <p v-if="title"><strong>{{title}}</strong></p>
            <div v-if="text" v-html="text"></div>
        </div>
        <slot name="login"/>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
export default {
    components: {
        Icon
    },
    props: {
        face: {
            type: Boolean,
            default: true
        },
        icon: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'SEARCH'
        },
        systemErrorType: {
            type: Number,
            default: null
        },
        poiSystemError: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            types: {
                'CAR': {
                    message: 'road', 
                    label: 'PKW',
                },
                'PUBLIC': {
                    message: 'public',
                    label: 'Öffentlicher Verkehr',
                },
                'FOOT': {
                    message: 'foot', 
                    label: 'Fußgänger',
                },
                'BIKE': {
                    message: 'foot', 
                    label: 'Fahrrad',
                },
                'MOTORCYCLE': {
                    message: 'road', 
                    label: 'Motorrad',
                },
                'PARK_AND_RIDE': {
                    message: 'share',
                    label: 'Park & Ride',
                },
                'BIKE_AND_RIDE': {
                    message: 'share',
                    label: 'Bike & Ride',
                },
                'CAMPER': {
                    message: 'road', 
                    label: 'Wohnmobil',
                },
                'TRAILER': {
                    message: 'road', 
                    label: 'Gespann',
                },
                'SHARING': {
                    message: 'share', 
                    label: 'Sharing',
                },
                'BIKE_SHARING': {
                    message: 'share',
                    label: 'Bike Sharing',
                },
                'CAR_TRAIN': {
                    message: 'public', 
                    label: 'Autoreisezug',
                },
                'LIST': {
                    message: 'list', 
                    label: '',
                },
                'SEARCH': {
                    message: 'search', 
                    label: '',
                },
                'POI_GENERAL': {
                    message: 'poiGeneral', 
                    label: '',
                },
                'POI_FAVOURITES': {
                    message: 'poiFavourites', 
                    label: '',
                },
                'POI_FAVOURITES_NOT_LOGGED_IN': {
                    message: 'poiFavouritesNotLoggedIn', 
                    label: '',
                },
                'POI_ROUTE': {
                    message: 'poiRoute', 
                    label: '',
                },
                'STEPS': {
                    message: 'steps',
                    label: ''
                },
                'COUNTRYINFO': {
                    message: 'countryinfo',
                    label: ''
                },
                'NO_VISIBLE_RESULTS': {
                    message: 'noVisibleResults',
                    label: ''
                },
                'NO_ROUTE_OVERVIEW': {
                    message: 'noRouteOverview',
                    label: ''
                }
            },
            content: {
                titles: {
                    list: 'Es konnte leider keine Route berechnet werden',
                    road: 'Es konnte leider keine [[mode]]-Route berechnet werden',
                    foot: 'Leider konnte zu Ihrer Anfrage keine [[mode]]-Route berechnet werden.',
                    share: 'Leider konnte zu Ihrer Anfrage keine [[mode]]-Route berechnet werden.',
                    public: 'Leider konnte zu Ihrer Anfrage keine Verbindung gefunden werden',
                    poiGeneral: 'Für den aktuellen Kartenausschnitt liegen keine Ergebnisse vor',
                    poiFavourites: '',
                    poiFavouritesNotLoggedIn: '',
                    poiRoute: 'Entlang der berechneten Route liegen keine Ergebnisse vor.',
                    system400public: 'Eine Route mit Öffentlichen Verkehrsmitteln ist nur innerhalb Österreichs möglich.',
                    system400rest: 'Eine [[mode]]-Route ist nur innerhalb Österreichs möglich.',
                    system422public: 'Zu Ihrer Anfrage konnte keine Verbindung gefunden werden.',
                    system422rest: 'Zu Ihrer Anfrage konnte keine [[mode]]-Route berechnet werden.',
                    system500: 'Ihre Route konnte auf Grund eines technischen Problems nicht berechnet werden.',
                    noVisibleResults: 'Für den aktuellen Kartenausschnitt liegen keine Ergebnisse vor.',
                    systemPoi: 'Leider konnten auf Grund eines technisches Problems keine Ergebnisse gefunden werden.',
                    noRouteOverview: '',
                },
                texts: {
                    list: '<p>Dies kann unter Umständen an der Fahrzeugkategorie (z.B. die gewünschte Route ist aktuell gesperrt oder ungeeignet für die gewählte Fahrzeugkategorie) oder den Routenoptionen (z.B. keine Route ohne Maut oder Tunnel möglich) liegen. Bitte versuchen Sie es mit anderen Einstellungen erneut.</p>',
                    road: '<p>Dies kann unter Umständen an der Fahrzeugkategorie (z.B. die gewünschte Route ist aktuell gesperrt oder ungeeignet für die gewählte Fahrzeugkategorie) oder den Routenoptionen (z.B. keine Route ohne Maut oder Tunnel möglich) liegen. Bitte versuchen Sie es mit anderen Einstellungen erneut.</p>',
                    foot: '<p>Dies kann unter Umständen an den von Ihnen gewählten Routenoptionen liegen. Bitte versuchen Sie die Abfrage mit anderen Einstellungen erneut.</p>',
                    share: '<p>Dies kann unter Umständen an den von Ihnen gewählten Routenoptionen liegen. Bitte versuchen Sie die Abfrage mit anderen Einstellungen erneut.</p><p>Wichtiger Hinweis: Derzeit sind [[mode]]-Routen nur innerhalb Österreich möglich.</p>',
                    public: '<p>Dies kann unter Umständen an den von Ihnen gewählten Routenoptionen liegen. Bitte versuchen Sie die Abfrage mit anderen Einstellungen erneut.</p><p>Wichtiger Hinweis: Derzeit sind Verbindungen mit den öffentlichen Verkehrsmitteln nur innerhalb Österreichs und zu ausgewählten Destinationen im Ausland möglich.',
                    system400public: '<p>Außerhalb Österreichs können Sie Routen für Auto, Motorrad, Wohnmobil, Gespann, Fahrrad oder Fußweg berechnen.</p>',
                    system400rest: '<p>Außerhalb Österreichs können Sie Routen für Auto, Motorrad, Wohnmobil, Gespann, Fahrrad oder Fußweg berechnen.</p>',
                    system422public: '<p>Bitte überprüfen Sie Ihre gewählten Adressen, Ihre Einstellungen und ob die gewünschte Strecke für dieses Verkehrsmittel geeignet ist.</p>',
                    system422rest: '<p>Bitte überprüfen Sie Ihre gewählten Adressen, Ihre Einstellungen und ob die gewünschte Strecke für dieses Verkehrsmittel geeignet ist.</p>',
                    system500: '<p>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>',
                    search: '<p>Es konnte leider kein Ergebnis gefunden werden. Bitte versuchen Sie es mit einem anderen Begriff.</p>',
                    poiGeneral: 'Bitte ändern Sie den Kartenausschnitt und versuchen Sie es erneut, indem Sie danach auf „Hier suchen” klicken.',
                    poiFavourites: 'Noch keine Favoriten in diesem Kartenausschnitt gespeichert. Wichtige Informationen mit einem Klick auf das Stern-Symbol merken.',
                    poiFavouritesNotLoggedIn: 'Zur Anzeige von Favoriten ist ein Login erforderlich.',
                    poiRoute: 'Versuchen Sie es erneut, indem Sie den Suchradius entlang der Route erweitern.',
                    steps: 'Es konnte leider keine Streckenbeschreibung geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    countryinfo: 'Es konnten leider keine Länderinfos geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    general: '<p>Etwas ist schief gelaufen, bitte versuchen Sie es erneut.</p>',
                    noVisibleResults: '<p>Bitte ändern Sie den Kartenausschnitt, um Ergebnisse entlang Ihrer Route zu sehen.</p>',
                    systemPoi: '<p>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>',
                    noRouteOverview: '<p>Derzeit gibt es keine wichtigen Routenhinweise für Ihre Strecke, wir wünschen Ihnen eine gute Fahrt!<br><br>Bitte beachten Sie dennoch relevante Verkehrsbestimmungen in der Länderinfo.</p>'
                },
            }

        }
    },
    computed: {
        title() {
            const textKey = this.getTextKey();
            if(textKey) {
                if(this.content.titles[textKey]) {
                    return this.insertMode(this.content.titles[textKey]);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        text() {
            const textKey = this.getTextKey();
            if(textKey) {
                if(this.content.texts[textKey]) {
                    return this.insertMode(this.content.texts[textKey]);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
    },
    methods: {
        insertMode(text) {
            if(text.indexOf('[[mode]]') >= 0) {
                return text.replace('[[mode]]', this.types[this.type].label);
            } else {
                return text;
            }
        },
        getTextKey() {
            if(this.systemErrorType) {
                if (this.systemErrorType === 400) {
                    switch (this.type) {
                        case 'PUBLIC': {
                            return 'system400public'
                        }
                        case 'PARK_AND_RIDE':
                        case 'BIKE_AND_RIDE':
                        case 'SHARING':
                        case 'BIKE':
                        case 'FOOT': {
                            return 'system400rest'
                        }
                    }   
                } else if (this.systemErrorType === 422) {
                    switch (this.type) {
                        case 'PUBLIC':
                        case 'PARK_AND_RIDE':
                        case 'BIKE_AND_RIDE':
                        case 'SHARING': {
                            return 'system422public'
                        }
                        case 'CAR':
                        case 'BIKE':
                        case 'FOOT':
                        case 'CAMPER':
                        case 'TRAILER': {
                            return 'system422rest'
                        }
                    }  
                } else if (this.systemErrorType === 500 || this.systemErrorType === 502) {
                    return 'system500';
                }
            } else if(this.poiSystemError) {
                return 'systemPoi'
            } else {
                if(this.types[this.type]) {
                    return this.types[this.type].message;
                } else {
                    return false;
                }
            }
        },
    },
}
</script>

<style lang="scss">
.no-results-message {
    $block: &;
    padding: 50px 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &__image {
        width: 32px;
        margin-bottom: 16px;
        display: block;
    }
    &__icon {
        margin-bottom: 16px;
        color: $color-grey;
    }
    &__text {
        text-align: center;
        color: $color-black-05;
        p {
            margin: 0 0 0.5em;
            strong {
                color: $color-black;
                opacity: 0.6;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>